import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import type { UseUserNavigationReturn } from './useUserNavigation.types';

export function useUserNavigation(): UseUserNavigationReturn {
  const navigate = useNavigate();
  const { customerId } = useParams<{ customerId: string }>();
  const basePath = `/manage/${customerId}/users`;

  const navigateToUser = React.useCallback(
    (userId: string): void => {
      navigate(`${basePath}/${userId}`);
    },
    [navigate, basePath]
  );

  const navigateToCreateUser = React.useCallback((): void => {
    navigate(`${basePath}/new`);
  }, [navigate, basePath]);

  const navigateToUsersList = React.useCallback((): void => {
    navigate(basePath);
  }, [navigate, basePath]);

  const navigateToChangeRequest = React.useCallback(
    (userId: string): void => {
      navigate(`${basePath}/${userId}/change-request`);
    },
    [navigate, basePath]
  );

  return {
    navigateToUser,
    navigateToCreateUser,
    navigateToUsersList,
    navigateToChangeRequest,
  };
}
